import { AnalyticsEvent, AnalyticsProvider, VideoEvent, WatchTimeEvent } from './types';
import { GoogleAnalyticsProvider } from './providers/GoogleAnalyticsProvider';

class AnalyticsService {
  private static instance: AnalyticsService;
  private providers: AnalyticsProvider[] = [];

  private constructor() {
    // Initialize providers
    this.providers.push(new GoogleAnalyticsProvider());
  }

  public static getInstance(): AnalyticsService {
    if (!AnalyticsService.instance) {
      AnalyticsService.instance = new AnalyticsService();
    }
    return AnalyticsService.instance;
  }

  public async initialize(): Promise<void> {
    await Promise.all(this.providers.map(provider => provider.initialize()));
  }

  public trackEvent(event: AnalyticsEvent): void {
    this.providers.forEach(provider => provider.trackEvent(event));
  }

  public trackPageView(path: string): void {
    this.providers.forEach(provider => provider.trackPageView(path));
  }

  public trackVideoEvent(event: VideoEvent): void {
    this.providers.forEach(provider => provider.trackVideoEvent(event));
  }

  public trackWatchTime(event: WatchTimeEvent): void {
    this.providers.forEach(provider => provider.trackWatchTime(event));
  }

  public setUser(userId: string): void {
    this.providers.forEach(provider => provider.setUser(userId));
  }
}

export const analytics = AnalyticsService.getInstance(); 